import { createFileRoute } from '@tanstack/react-router'
import { ValueStoryDetails } from 'pages/valueStories/ValueStoryDetails'
import { z } from 'zod'

export const valueStoryDetailsSearchSchema = z.object({
  view: z.string().optional(),
  _refresh: z.number().optional(),
})

export const Route = createFileRoute('/value-stories/$siteID/$valueStoryID/')({
  component: ValueStoryDetails,
  staticData: {
    title: 'Value Story Details',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: valueStoryDetailsSearchSchema,
})
